/**
 * ECOTROPHY TROPHY STORIES & DISPATCHES
 * Lightweight controller for multi-image sliders on single trophy cards.
 */

(function () {
  'use strict';

  function initSliders(root) {
    var sliders = (root || document).querySelectorAll('[data-erd-slider]');

    sliders.forEach(function (sliderWrap) {
      var track = sliderWrap.querySelector('.erd-media-slider');
      var dots = sliderWrap.querySelectorAll('.erd-dot');
      if (!track) return;

      // Click dot to navigate
      if (dots.length) {
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var index = parseInt(this.getAttribute('data-index'), 10);
            var slideWidth = track.clientWidth;
            track.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
          });
        });
      }

      // Click arrows to navigate
      var prevBtn = sliderWrap.querySelector('.erd-nav-prev');
      var nextBtn = sliderWrap.querySelector('.erd-nav-next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var slideWidth = track.clientWidth || 300;
          track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var slideWidth = track.clientWidth || 300;
          track.scrollBy({ left: slideWidth, behavior: 'smooth' });
        });
      }

      // Update active dot on scroll
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            var scrollLeft = track.scrollLeft;
            var slideWidth = track.clientWidth || 1;
            var activeIdx = Math.round(scrollLeft / slideWidth);

            dots.forEach(function (dot, i) {
              if (i === activeIdx) {
                dot.classList.add('is-active');
              } else {
                dot.classList.remove('is-active');
              }
            });

            var slides = track.querySelectorAll('.erd-media-slide');
            slides.forEach(function (slide, i) {
              if (i === activeIdx) {
                slide.classList.add('is-active-slide');
              } else {
                slide.classList.remove('is-active-slide');
              }
            });

            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    });
  }

  function initScrollBlur(root) {
    var blurSections = (root || document).querySelectorAll('.erd-stories-section.has-scroll-blur');
    if (!blurSections.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      blurSections.forEach(function (sec) {
        sec.querySelectorAll('.erd-split-card, .erd-banner-card, .erd-gallery-block, .erd-gallery-item').forEach(function (el) {
          el.classList.add('is-in-focus');
        });
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-focus');
        } else {
          var rect = entry.boundingClientRect;
          // Re-blur only if it exits from the bottom of the viewport so scrolling feels alive
          if (rect.top > (window.innerHeight || document.documentElement.clientHeight)) {
            entry.target.classList.remove('is-in-focus');
          }
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -30px 0px'
    });

    blurSections.forEach(function (sec) {
      var items = sec.querySelectorAll('.erd-split-card, .erd-banner-card, .erd-gallery-block, .erd-gallery-item');
      items.forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  function init() {
    initSliders(document);
    initScrollBlur(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initSliders(e.target);
    initScrollBlur(e.target);
  });
})();
